import styled from 'styled-components';

export default styled.div`
  padding: 32px;
  @media screen and (max-width: ${props => props.theme.breakpoints.values.md}px) {
    padding: 24px;
  }
  @media screen and (max-width: ${props => props.theme.breakpoints.values.sm}px) {
    padding: 16px;
  }
`;
